import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  container: {
    border: "1px solid #70707043",
    borderRadius: "5px",
    marginBottom: theme.spacing(2),
  },
  topContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    padding: theme.spacing(1),
  },
  bottomContainer: {
    backgroundColor: "#F1E1E9",
    display: "flex",
    padding: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  rowWrapper: {
    display: "flex",
    marginBottom: "20px",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
    },
  },
  inputBackgroundColor: {
    backgroundColor: "#fff",
  },
  formHelperText: {
    marginLeft: "0px",
    position: "absolute",
    bottom: "-20px",
  },
  emailHelperText: {
    marginLeft: "0px",
  },
  textfieldFirstRow: {
    marginRight: "10px",
    "&:last-of-type": {
      marginRight: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "47%",
      "&:nth-of-type(2)": {
        marginRight: "0px !important",
      },
      "&:last-of-type": {
        width: "100%",
        marginRight: "10px",
      },

      marginBottom: "10px",
    },
  },
  textfieldSecondRow: {
    marginRight: "10px",
    width: "30%",
    "&:last-of-type": {
      marginRight: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "47%",
      marginBottom: "10px",
    },
  },
  textfieldThirddRow: {
    width: "23%",
    [theme.breakpoints.down("xs")]: {
      width: "47%",
      marginBottom: "10px",
      "&:last-of-type": {
        marginRight: "0px",
      },
    },
  },

  termDatePicker: {
    color: theme.palette.error.main,
    "& .MuiInputBase-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      "& .MuiError": {
        marginLeft: "0px",
        position: "absolute",
        bottom: "-20px",
      },
    },
  },
  boxRoot: {
    width: "30%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginBottom: "10px",
    },
    "& p": {
      marginLeft: "0px",
      position: "absolute",
      bottom: "-20px",
    },
  },
  dobDatePicker: {
    "& .MuiInputBase-root": {
      backgroundColor: "#fff",
      borderRadius: "5px",
    },
    "& > .MuiPickerDTToolbar-toolbar.MuiToolbar-root": {
      backgroundColor: "#fff",
      borderRadius: "5px",
      border: "1px solid red",
    },
  },
}))

export default styles
